<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="5.0053mm" height="5mm" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
  viewBox="0 0 12485 12472"
   xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Pracovní_x0020_plocha">
    <path class="fil0 str0" d="M0 2921c0,947 70,1505 377,2415 306,904 408,1094 867,1957 70,131 145,245 218,366 128,214 305,477 458,679 170,225 322,414 505,631 110,131 157,186 278,306 232,232 65,109 421,423 493,434 815,763 1430,1134 415,251 670,415 1116,638 1464,732 3652,1405 5376,712 269,-108 617,-283 826,-472 233,-209 475,-360 573,-758 196,-793 -364,-1170 -908,-1714l-925 -925c-440,-465 -1142,-470 -1645,38l-648 649c-352,337 -529,446 -1048,446 -194,0 -444,-124 -560,-219 -79,-64 -141,-106 -212,-177l-778 -780c-72,-72 -125,-121 -194,-196l-970 -977c-268,-289 -1193,-1143 -1342,-1385 -235,-381 -249,-776 -24,-1190 315,-580 1840,-1313 1167,-2420 -41,-67 -91,-132 -141,-184l-168 -157c-62,-62 -100,-100 -162,-162 -35,-35 -45,-46 -79,-83l-567 -570c-471,-426 -750,-946 -1391,-946 -921,0 -1483,1103 -1702,1869 -93,324 -148,652 -148,1052z"/>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'Support',
};
</script>

<style scoped>
.fil0 {fill:#666666}
.str0 {stroke:#666666;stroke-width:100}
</style>
